/**
 * APPLICATION ENTRY POINT (SWA VERSION)
 * =====================================
 * This is where the React app starts.
 *
 * Authentication: Azure Static Web Apps built-in auth (no MSAL needed)
 * UI Framework: Mantine v8
 * Build System: Vite
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from '@/pwa/registerServiceWorker';

registerServiceWorker();

// Build stamp for deployment tracking
console.log("PM App build:", import.meta.env.MODE, new Date().toISOString());
console.log("🔐 Auth Mode: Azure Static Web Apps (SWA) - No MSAL");

// Mantine v8
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@/ui/tokens.css';

const container = document.getElementById('root');
const root = createRoot(container!);

// Render app without MSAL - SWA handles authentication
root.render(
  <MantineProvider defaultColorScheme="light">
    <App />
  </MantineProvider>
);
